import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ProviderAvailabilityHeader: {
        id: 'Profile.Components.BookingSection.ProviderAvailabilityTooltip.Header',
        defaultMessage: '{firstName}, can\'t find the right time?',
    },
    ProviderAvailabilityMessage: {
        id: 'Profile.Components.BookingSection.ProviderAvailabilityTooltip.Message',
        defaultMessage: 'Let\'s help you find similar doctors with more availabilities in your area.',
    },
    ProviderAvailabilityButton: {
        id: 'Profile.Components.BookingSection.ProviderAvailabilityTooltip.ButtonText',
        defaultMessage: 'Find another {specialtyName}',
    },
});

export const tooltipBackgroundColor = '#59E3FF';
export const blobBackgroundColor = '#86EBFF';
